import React from 'react';
import { Box, Button, Typography, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { headerProps, headerTypographyProps } from '../styles/sxStyling';
import { UserConfigurableModule } from '../types/User';
import { IFilter } from './common/filters/interfaces';
import FilterAltIcon from '@mui/icons-material/FilterAlt';

interface IListHeaderProps {
  title: string;
  moduleFilters?: IFilter[];
  onNew?: () => void;
  module?: UserConfigurableModule;
  onToggleFilters?: () => void;
  filtersOpen?: boolean;
}

export default function ListHeader({ title, moduleFilters = [], onNew, module, onToggleFilters, filtersOpen = false }: IListHeaderProps) {
  const navigate = useNavigate();
  const handleCreate = onNew || (() => navigate('./new'));

  const showFilterButton = Boolean(module && moduleFilters.length > 0);

  return (
    <Box sx={headerProps}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography {...headerTypographyProps}>{title}</Typography>

        {showFilterButton && (
          <IconButton
            size="small"
            onClick={onToggleFilters}
            color={filtersOpen ? 'primary' : 'default'}
            aria-label="Toggle filters panel"
            aria-pressed={!!filtersOpen}
          >
            <FilterAltIcon />
          </IconButton>
        )}
      </Box>

      <Button onClick={handleCreate} color="primary" variant="contained">
        Add
      </Button>
    </Box>
  );
}
